import { Component, Input, OnInit } from '@angular/core';
import { RentalsUnitedService } from '../..';
import { first } from 'rxjs/operators';
import { AuthenticationService, UserService } from '@app/_services';
import { PropertyService } from '@app/_components/property';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ReportService } from '@app/_components/report';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ApiResponse } from '@app/_models';

@Component({
    selector: 'app-ru-availability',
    templateUrl: './ru-availability.component.html',
    styleUrls: ['./ru-availability.component.css'],
    standalone: false
})
export class RuAvailabilityComponent implements OnInit {

	selectedShortTermRental: any;
	ruAvailabilities: any = [];
	shortTermRentals: any = [];

	// data
	apiResponse: ApiResponse;

	@Input() ruAccount: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;
	formErrorMessage: String;

	validationMessages = {
		shortTermRentalId: [{ type: 'required', message: 'Property is required' }],
		startDate: [],
		endDate: []
	};

	constructor(
		private rentalsUnitedService: RentalsUnitedService,
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private propertyService: PropertyService,
		private router: Router,
		private messageService: MessageService,
		private route: ActivatedRoute,
		private reportService: ReportService,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder) { }



	ngOnInit(): void {
		this.buildForm();
		this.loadShortTermRentals();
	}

	onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		this.pushRuAvailability(this.form1.value);
	}

	onShowAvailability() {
		if (this.form1.invalid) {
			return;
		}
		this.loadRuAvailability(this.form1.value);
	}

	onSyncAllAvailabilityClick() {
		let ruRequest = { startDate: '', endDate: '' };
		this.pushAllAvailability(ruRequest);
	}

	pushAllAvailability(ruRequest) {
		this.formLoading = true;
		this.rentalsUnitedService.pushAllAvailability(ruRequest)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushAllAvailability: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Push All Availability', detail: '' + res.message, life: 3000 });
				},
				err => {
					console.log('error In pushAllAvailability is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'pushAllAvailability Failed', detail: 'We were unable to pushAllAvailability your RuProperties: ' + err.message, life: 3000 });
				},
				() => { this.formLoading = false; });
	}


	loadRuAvailability(form1) {
		this.formLoading = true;
		this.rentalsUnitedService.listAvailability(form1)
			.pipe(first())
			.subscribe(
				res => {
					console.log('loadRuAvailability: ' + JSON.stringify(res));
					this.ruAvailabilities = res.data.availabilities.CalDay;
				},
				err => {
					console.log('error In loadRuAvailability is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'loadRuProperties Failed', detail: 'We were unable to retrieve your RuProperties: ' + err.message, sticky: false });
				},
				() => { this.formLoading = false; });
	}


	pushRuAvailability(form1) {
		this.formLoading = true;
		this.rentalsUnitedService.pushAvailability(form1)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushRuAvailability: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Push Availability', detail: '' + res.message, sticky: false });
					this.loadRuAvailability(this.form1.value);
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'pushRuAvailability Failed', detail: 'We were unable to push the availability: ' + err, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList()
			.subscribe(
				res => {
					// console.log('loadShortTermRentals SUCCESS: ' + JSON.stringify(res.data.propertySummaryList));
					this.shortTermRentals = res.data.propertySummaryList;
					this.shortTermRentals.unshift({});
				},
				err => {
					console.log('loadShortTermRentals FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'loadShortTermRentals Failed', detail: 'We were unable to retrieve your shortTermRentals: ' + err.message, sticky: false });
				},
				() => { this.formLoading = false; });
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			shortTermRentalId: ['', Validators.required],
			startDate: [''],
			endDate: [''],
			ruAccount: [this.ruAccount],
		});
	}
}
